// english
export default {
  // 登录模块
  login_btn: '登录',
  login_description:
    'MBE运维管理系统可实现远程监控、远程调试、远程诊断等功能。',
  login_forgot_link_text: '忘记密码?',

  login_form_username_placeholder: '用户名',
  login_form_username_required_msg: '用户名不能为空',
  login_form_captcha_placeholder: '验证码',
  login_form_captcha_required_msg: '验证码不能为空',
  login_form_password_placeholder: '密码',
  login_form_password_required_msg: '密码不能为空',

  login_form_error_userinfo: '获取用户信息失败，请刷新并重试',
  login_copyright: '',
};
